/**
 * "Stay signed in" — the person's own choice about how long a session on THIS
 * device lasts, remembered so it is also the default next time they sign in.
 *
 * On: the server gives the session the long, sliding refresh window
 * (`Jwt:RememberMeRefreshTokenExpiryDays`), re-stamped on every refresh — so as
 * long as they keep using the app they are never signed out. Off: the short
 * `Jwt:RefreshTokenExpiryDays` window, for a borrowed or shared device.
 *
 * It lives in localStorage rather than being threaded through each call because
 * Google and Apple sign-in leave the page and come back — the choice has to
 * survive the redirect. Every auth call reads it from here (`authService`,
 * `AuthContext`), so there is one answer per device.
 *
 * Default ON. Someone who never touches the control gets the forever session.
 */
const KEY = 'pr.staySignedIn';

/** True unless they explicitly turned it off on this device. */
export function getStaySignedIn() {
  try {
    return localStorage.getItem(KEY) !== 'false';
  } catch {
    // Private mode / storage disabled: there is nowhere to remember a session
    // anyway, so the answer hardly matters — give the friendlier one.
    return true;
  }
}

export function setStaySignedIn(on) {
  try {
    localStorage.setItem(KEY, on ? 'true' : 'false');
  } catch {
    /* nothing to do — the next read falls back to true */
  }
}
